// src/components/TokenBar/TokenBar.js
import React, { useMemo } from 'react';

// Contextos
import { useSessionTimer } from '../../contexts/SessionTimerContext';
import { useAuth } from '../../contexts/AuthContext';
import { useModal } from '../../contexts/ModalContext';

// Estilos
import styles from './tokenbar.module.css';

function formatRemainingShort(timeLeft) {
  if (timeLeft == null) return '';
  if (timeLeft < 60) return `${Math.max(0, timeLeft)} segundo(s)`;
  const mins = Math.floor(timeLeft / 60);
  return `${mins} minuto(s)`;
}

function formatRemainingSentence(timeLeft) {
  if (timeLeft == null) return '';
  if (timeLeft < 60) return `Aproximadamente ${Math.max(0, timeLeft)} segundo(s)`;
  const mins = Math.floor(timeLeft / 60);
  return `Aproximadamente ${mins} minuto(s)`;
}

export default function TokenBar() {
  const { percent, progress, timeLeft, timeTotal, renewNow } = useSessionTimer();
  const { isAuthenticated } = useAuth();
  const { showModal } = useModal();

  const safePercent = typeof percent === 'number' ? percent : 0;

  const widthStyle = useMemo(() => {
    return { width: `${safePercent}%` };
  }, [safePercent]);

  // Cores por limiar ( #00AFA9 >40, #A86CF7 >20, #EA1D75 ≤20 )
  const colorFill =
    safePercent > 40 ? '#00AFA9' : safePercent > 20 ? '#A86CF7' : '#EA1D75';

  const timeText =
    timeLeft != null && timeTotal != null
      ? `${formatRemainingSentence(timeLeft)} restantes da sessão`
      : 'Sessão ativa';

  if (!isAuthenticated || progress == null) return null;

  const handleClickBar = () => {
    const short = formatRemainingShort(timeLeft);
    const body =
      timeLeft != null
        ? (timeLeft > 60
            ? `Seu token expira em aproximadamente ${short}. Deseja renovar agora para não perder seu progresso?`
            : 'Seu token está para expirar. Deseja renovar agora para não perder o que está fazendo?')
        : 'Deseja renovar sua sessão agora?';

    showModal(
      'Renovar sessão',
      body,
      async () => {
        await renewNow();
      },
      () => {
        // nada ao cancelar
      }
    );
  };

  return (
    <div className={styles.container} aria-hidden={!isAuthenticated}>
      <div
        className={styles.track}
        onClick={handleClickBar}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClickBar();
          }
        }}
        style={{ cursor: 'pointer' }}
      >
        <div
          className={styles.fill}
          style={{ ...widthStyle, background: colorFill }}
          aria-label="Token time left"
        />
        <div className={styles.timeLabel}>
          {timeText}
        </div>
      </div>
    </div>
  );
}